export const ToastConfig = {
  common: {
    position: "top",
    duration: 1200,
  },

  error: {
    position: "top",
    duration: 5000,
  },
};

export const AutomatedReportStatusLabels = Object.freeze({
  PENDING: "null",
  FAILED: "null",
  SCRIPT_GENERATED: "null",
  NO_FINDINGS: "특이사항 없음",
  LOW_SCRIPT_QUALITY: "품질 미달",
  REPORT_CONTENT_GENERATED: "특이사항 있음",
});

export const AutomatedReportStatusColors = Object.freeze({
  PENDING: {
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
  },
  FAILED: {
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
  },
  SCRIPT_GENERATED: {
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
  },
  NO_FINDINGS: {
    backgroundColor: "#d1ecf1",
    color: "#0c5460",
  },
  LOW_SCRIPT_QUALITY: {
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
  },
  REPORT_CONTENT_GENERATED: {
    backgroundColor: "#fde0de",
    color: "#7f1d1d",
  },
});
